// 1.

// import React, { useState, useEffect } from "react";
// import { Carousel } from "react-responsive-carousel";
// import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import carousel styles

// import { InverterDetail } from "../../../../../../api/Api";
// import "./MainSlider.css";

// const MainSlider = () => {
//   const [logData, setLogData] = useState([]);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const [credentials] = useState({
//     LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//     LOC_CODE: sessionStorage.getItem("LCODE") || "",
//     PASS_KEY: sessionStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//     WEB_KEY: sessionStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//   });

//   const fetchLogData = async () => {
//     setLoading(true);
//     try {
//       const res = await InverterDetail(credentials);
//       if (res?.data && Array.isArray(res.data)) {
//         const uniqueData = res.data.filter(
//           (item, index, self) =>
//             index === self.findIndex((t) => t.NAME === item.NAME)
//         );
//         setLogData(uniqueData);
//       } else {
//         setLogData([]);
//       }
//     } catch (err) {
//       setError("Failed to fetch data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLogData();
//     const intervalId = setInterval(fetchLogData, 30000);
//     return () => clearInterval(intervalId);
//   }, [credentials.LOGIN_ID]);

//   return (
//     <div className="container">
//       {loading && <p>Loading...</p>}
//       {error && <p style={{ color: "red" }}>{error}</p>}
//       <Carousel
//         autoPlay={true}
//         interval={2000}
//         infiniteLoop={true}
//         showArrows={true}
//         showIndicators={true}
//         showThumbs={false}
//       >
//         {logData.map((item, index) => (

//           <div key={index} className="card px-1  shadow-sm rounded-sm" style={{ border: "none" }}>

//             <div className="card-body" style={{ wordBreak: "break-word" }}>

//               <div className="text-start">
//                 <h6 className="card-title ">
//                   <span style={{ color: "#013b7b", fontSize: "1rem" }}>{item.NAME}</span>
//                 </h6>

//                 <p style={{ flexWrap: "wrap", wordBreak: "break-word" }}>
//                   Live:
//                   <span style={{ fontSize: "16px", color: "#013b7b" }}>{item.KW}</span>
//                   <span style={{ color: "red" }}> kW</span>
//                 </p>

//                 <p style={{ flexWrap: "wrap", wordBreak: "break-word" }}>
//                   Today Yield:
//                   <span style={{ fontSize: "16px", color: "#013b7b" }}>{item.DAY_KWH}</span>
//                   <span style={{ color: "red" }}> kWh</span>
//                 </p>

//                 <p>
//                   <strong>Status:</strong>&nbsp;
//                   <span style={{ color: item.STS === "Online" ? "green" : "red" }}>{item.STS}</span>
//                 </p>
//                 {/* 
//                 <p>
//                   <strong>Date:</strong>&nbsp;
//                   <span style={{ color: "#013b7b" }}>{item.E_DATE || "N/A"}</span>
//                 </p> */}
//               </div>

//               <div className="text-start" >
//                 <h5 className="card-title mb-3">
//                   <span style={{ color: "#013b7b", wordBreak: "break-word" }}></span>
//                 </h5>

//                 <p style={{ flexWrap: "wrap", overflowWrap: "break-word" }}>
//                   Make:&nbsp;
//                   <span style={{ color: "#013b7b" }}>{item.MAKE}</span>

//                 </p>

//                 {item.AC_CAP && (
//                   <p style={{ flexWrap: "wrap", wordBreak: "break-word" }}>
//                     AC Capacity:
//                     <span style={{ color: "#013b7b" }}>{item.AC_CAP}</span>
//                   </p>
//                 )}

//                 <p style={{ flexWrap: "wrap", wordBreak: "break-word" }}>
//                   {item.CAPACITY_PREFIX}
//                   <span style={{ color: "#013b7b" }}>{item.KWP}</span>
//                 </p>

//                 <p style={{ flexWrap: "wrap", wordBreak: "break-word" }}>
//                   Life_kWh:&nbsp;
//                   <span style={{ color: "#013b7b" }}>{item.TOT_GEN}</span>
//                 </p>

//                 <p style={{ flexWrap: "wrap", wordBreak: "break-word" }}>
//                   Event:
//                   <span style={{ color: "#013b7b" }}>{item.ALARM || "N/A"}</span>
//                 </p>


//                 <p>
//                   <strong>Date:</strong>&nbsp;
//                   <span style={{ color: "#013b7b" }}>{item.E_DATE || "N/A"}</span>
//                 </p>
//               </div>

//               <div></div>





//             </div>

//           </div>
//         ))}
//       </Carousel>
//     </div>
//   );
// };

// export default MainSlider;

// latest code 

// import React, { useState, useEffect } from "react";
// import { Carousel } from "react-responsive-carousel";
// import "react-responsive-carousel/lib/styles/carousel.min.css";

// import { InverterDetail } from "../../../../../../api/Api";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Grid,
//   Box,
//   Divider,
// } from "@mui/material";

// const MainSlider = () => {
//   const [logData, setLogData] = useState([]);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const [credentials] = useState({
//     LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//     LOC_CODE: sessionStorage.getItem("LCODE") || "",
//     PASS_KEY: sessionStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//     WEB_KEY: sessionStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//   });

//   const fetchLogData = async () => {
//     setLoading(true);
//     try {
//       const res = await InverterDetail(credentials);
//       if (res?.data && Array.isArray(res.data)) {
//         const uniqueData = res.data.filter(
//           (item, index, self) =>
//             index === self.findIndex((t) => t.NAME === item.NAME)
//         );
//         setLogData(uniqueData);
//       } else {
//         setLogData([]);
//       }
//     } catch (err) {
//       setError("Failed to fetch data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLogData();
//     const intervalId = setInterval(fetchLogData, 300000);
//     return () => clearInterval(intervalId);
//   }, [credentials.LOGIN_ID]);

//   return (
//     <Box className="container" sx={{ mt: 2 }}>
//       {loading && <Typography>Loading...</Typography>}
//       {error && <Typography color="error">{error}</Typography>}

//       <Carousel
//         autoPlay
//         interval={3000}
//         infiniteLoop
//         showArrows
//         showIndicators
//         showThumbs={false}
//         dynamicHeight={false}
//         centerMode={false}
//       >
//         {logData.map((item, index) => (

//           <CardContent sx={{ p: 1.5 }}>
//             {/* Header */}
//             <Grid container justifyContent="space-between" alignItems="center" mb={0.5}> {/* reduced bottom margin */}
//               <Typography
//                 variant="subtitle1"
//                 color="primary"
//                 sx={{
//                   fontSize: "1.3rem",
//                   lineHeight: 1.2,  // reduces vertical space
//                   py: 0            // removes any vertical padding if present
//                 }}
//               >
//                 {item.NAME}
//               </Typography>
//             </Grid>
//             <Divider sx={{ mb: 0.5 }} /> {/* smaller bottom margin */}

//             {/* Two Column Layout */}
//             <Grid container spacing={2} sx={{ px: 0.5 }}> {/* spacing adds gutter between columns */}
//               {/* Left Column */}
//               <Grid item xs={6} sx={{ pr: 2 }}> {/* padding-right to separate visually */}
//                 <Grid container justifyContent="space-between">
//                   <Typography sx={{ fontSize: "0.8rem" }}>⚡ Live:</Typography>
//                   <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
//                     {item.KW} <span style={{ color: "red" }}>kW</span>
//                   </Typography>
//                 </Grid>
//                 <Grid container justifyContent="space-between">
//                   <Typography sx={{ fontSize: "0.8rem" }}>🌞 Today Yield:</Typography>
//                   <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
//                     {item.DAY_KWH} <span style={{ color: "red" }}>kWh</span>
//                   </Typography>
//                 </Grid>
//                 <Grid container justifyContent="space-between">
//                   <Typography sx={{ fontSize: "0.8rem" }}>🏭 Make/Device:</Typography>
//                   <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
//                     {item.MAKE}
//                   </Typography>
//                 </Grid>
//                 {item.AC_CAP && (
//                   <Grid container justifyContent="space-between">
//                     <Typography sx={{ fontSize: "0.8rem" }}>🔋 AC Capacity:</Typography>
//                     <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
//                       {item.AC_CAP}
//                     </Typography>
//                   </Grid>
//                 )}
//                 <Grid container justifyContent="space-between">
//                   <Typography sx={{ fontSize: "0.8rem" }}>🔋 {item.CAPACITY_PREFIX}</Typography>
//                   <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
//                     {item.KWP}
//                   </Typography>
//                 </Grid>
//               </Grid>

//               {/* Right Column */}
//               <Grid item xs={6} sx={{ pl: 2 }}> {/* padding-left for visual separation */}
//                 <Grid container justifyContent="space-between">
//                   <Typography sx={{ fontSize: "0.8rem" }}> {item.STS === "Online" ? "🟢" : "🔴"} Status:</Typography>
//                   <Typography sx={{
//                     color: item.STS === "Online" ? "green" : "red",
//                     fontWeight: "bold",
//                     fontSize: "0.8rem",
//                   }}>
//                     {item.STS}
//                   </Typography>
//                 </Grid>

//                 <Grid container justifyContent="space-between">
//                   <Typography sx={{ fontSize: "0.8rem" }}>📈 Life kWh:</Typography>
//                   <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
//                     {item.TOT_GEN}
//                   </Typography>
//                 </Grid>
//                 <Grid container justifyContent="space-between">
//                   <Typography sx={{ fontSize: "0.8rem" }}>🚨 Event:</Typography>
//                   <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
//                     {item.ALARM || "N/A"}
//                   </Typography>
//                 </Grid>
//                 <Grid container justifyContent="space-between">
//                   <Typography sx={{ fontSize: "0.8rem" }}>🕒 Date:</Typography>
//                   <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
//                     {item.E_DATE || "N/A"}
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Grid>


//           </CardContent>

//         ))}
//       </Carousel>



//     </Box>
//   );
// };

// export default MainSlider;



// 2.

import React, { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import { InverterDetail } from "../../../../../../api/Api";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Divider,
} from "@mui/material";

const MainSlider = () => {
  const [logData, setLogData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // एक्टिव स्लाइड को ट्रैक करने के लिए स्टेट (दूसरे प्रोजेक्ट की तरह)
  const [currentIndex, setCurrentIndex] = useState(0);

  const [credentials] = useState({
    LOGIN_ID: sessionStorage.getItem("LoginID") || "",
    LOC_CODE: sessionStorage.getItem("LCODE") || "",
    PASS_KEY: sessionStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
    WEB_KEY: sessionStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
  });

  const fetchLogData = async () => {
    setLoading(true);
    try {
      const res = await InverterDetail(credentials);
      if (res?.data && Array.isArray(res.data)) {
        const uniqueData = res.data.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.NAME === item.NAME)
        );
        setLogData(uniqueData);
        setCurrentIndex(0); // नया डेटा लोड होने पर पहली स्लाइड से शुरू करें
      } else {
        setLogData([]);
      }
    } catch (err) {
      setError("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogData();
    const intervalId = setInterval(fetchLogData, 300000);
    return () => clearInterval(intervalId);
  }, [credentials.LOGIN_ID]);

  // जबरन ऑटो-स्क्रॉलिंग (Force Auto-scroll) के लिए इफेक्ट जो आपने मांगा था
  
  useEffect(() => {
    if (logData.length <= 1) return;

    const scrollInterval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % logData.length);
    }, 2000); // हर 2 सेकंड में बदलेगा

    return () => clearInterval(scrollInterval);
  }, [logData]);

  return (
    <Box className="container" sx={{ mt: 2 }}>
      {loading && <Typography>Loading...</Typography>}
      {error && <Typography color="error">{error}</Typography>}

      {logData.length > 0 && (
        <Carousel
          selectedItem={currentIndex}                  
          onChange={(index) => setCurrentIndex(index)} 
          infiniteLoop={true}
          stopOnHover={false}
          showArrows={true}
          showIndicators={true}
          showThumbs={false}
          dynamicHeight={false}
          centerMode={false}
        >
          {logData.map((item, index) => (
            <CardContent key={index} sx={{ p: 1.5 }}>
              {/* Header */}
              <Grid container justifyContent="space-between" alignItems="center" mb={0.5}>
                <Typography
                  variant="subtitle1"
                  color="primary"
                  sx={{
                    fontSize: "1.3rem",
                    lineHeight: 1.2,
                    py: 0
                  }}
                >
                  {item.NAME}
                </Typography>
              </Grid>
              <Divider sx={{ mb: 0.5 }} />

              {/* Two Column Layout */}
              <Grid container spacing={2} sx={{ px: 0.5 }}>
                {/* Left Column */}
                <Grid item xs={6} sx={{ pr: 2 }}>
                  <Grid container justifyContent="space-between">
                    <Typography sx={{ fontSize: "0.8rem" }}>⚡ Live:</Typography>
                    <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                      {item.KW} <span style={{ color: "red" }}>kW</span>
                    </Typography>
                  </Grid>
                  <Grid container justifyContent="space-between">
                    <Typography sx={{ fontSize: "0.8rem" }}>🌞 Today Yield:</Typography>
                    <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                      {item.DAY_KWH} <span style={{ color: "red" }}>kWh</span>
                    </Typography>
                  </Grid>
                  <Grid container justifyContent="space-between">
                    <Typography sx={{ fontSize: "0.8rem" }}>🏭 Make/Device:</Typography>
                    <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                      {item.MAKE}
                    </Typography>
                  </Grid>
                  {item.AC_CAP && (
                    <Grid container justifyContent="space-between">
                      <Typography sx={{ fontSize: "0.8rem" }}>🔋 AC Capacity:</Typography>
                      <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                        {item.AC_CAP}
                      </Typography>
                    </Grid>
                  )}
                  <Grid container justifyContent="space-between">
                    <Typography sx={{ fontSize: "0.8rem" }}>🔋 {item.CAPACITY_PREFIX}</Typography>
                    <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                      {item.KWP}
                    </Typography>
                  </Grid>
                </Grid>

                {/* Right Column */}
                <Grid item xs={6} sx={{ pl: 2 }}>
                  <Grid container justifyContent="space-between">
                    <Typography sx={{ fontSize: "0.8rem" }}> {item.STS === "Online" ? "🟢" : "🔴"} Status:</Typography>
                    <Typography sx={{
                      color: item.STS === "Online" ? "green" : "red",
                      fontWeight: "bold",
                      fontSize: "0.8rem",
                    }}>
                      {item.STS}
                    </Typography>
                  </Grid>

                  <Grid container justifyContent="space-between">
                    <Typography sx={{ fontSize: "0.8rem" }}>📈 Life kWh:</Typography>
                    <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                      {item.TOT_GEN}
                    </Typography>
                  </Grid>
                  <Grid container justifyContent="space-between">
                    <Typography sx={{ fontSize: "0.8rem" }}>🚨 Event:</Typography>
                    <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                      {item.ALARM || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid container justifyContent="space-between">
                    <Typography sx={{ fontSize: "0.8rem" }}>🕒 Date:</Typography>
                    <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                      {item.E_DATE || "N/A"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          ))}
        </Carousel>
      )}
    </Box>
  );
};

export default MainSlider;